import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  button_boost: {
    height: 60,
  },
}));
